export default {
  title: "権限付与",
  form: {
    origanizations: "組織",
    roleName: "権限タイプ名",
    search: {
      title: "ユーザー検索",
      organization: "組織",
      userName: "ユーザー名",
      search: "検索",
    },
    header: {
      id: "ID",
      organization: "所属会社",
      userName: "ユーザー名",
      email: "email",
    },
    result: "検索結果",
    targetUser: "対象ユーザー",
    allSelect: "すべて選択",
  },
  modal: {
    notClearable: {
      row1: "権限が0件になるアカウントが含まれています。",
      row2: "アカウントに権限は必須です。",
    },
    duplicationConfirm: {
      row1: "同じ運営会社または組織で別の権限が付与されているアカウントが含まれています。",
      row2: "実行すると権限が上書きされます。",
    }
  },
  validations: {
    organization: {
      required: "組織を選択してください。",
    },
    roleType: {
      required: "権限タイプ名を選択してください。",
    },
    userSearch: {
      orzanization: {
        required: "組織を選択してください。",
      }
    }
  }
}
